export const searchConstantsUk = {
  types: [
    {
      key: 'arret',
      labelId: 'app.pages.search.labelType.decision',
    },
  ],
};
